/** Italian overlay for the IA restructure. */

const taxonomyIt = {
  family: 'Famiglia',
  families: {
    all_weather: 'Ogni clima',
    directional: 'Direzionale',
    market_neutral: 'Neutrale al mercato',
    momentum: 'Impulso',
    high_octane: 'Alto ottanaggio',
    intraday: 'Intraday',
  },
  familyCopy: {
    all_weather: 'Portafogli diversificati per regime. Beta azionario più basso, percorso più lento, zavorra per un portafoglio.',
    directional: 'Timing di indici e macro. Partecipa ai trend, si mette da parte quando la salute del mercato si deteriora.',
    market_neutral: 'Long/short azionario con beta vicino a zero. Un diversificatore, non una scommessa di mercato.',
    momentum: 'Momentum azionario USA su più orizzonti. Segue la forza; resta indietro nella mean-reversion.',
    high_octane: 'Risk-on / risk-off con leva. Soffitto più alto, drawdown più profondi.',
    intraday: 'Futures Nasdaq intraday. Ingressi sistematici dentro ogni sessione, flat alla sua chiusura. Nessuna posizione passa alla sessione successiva; l’edge vive nel regime di volatilità.',
  },
};

export const iaIt = {
  nav: {
    portfolio: 'Portafoglio',
    research: 'Ricerca',
    reports: 'Report',
    quantLab: 'Lab quantitativo',
    macroTerminal: 'Terminale',
    institutional: 'Istituzionale',
    more: 'Altro',
    account: 'Account',
    login: 'Accedi',
    about: 'Chi sono',
    performance: 'Rendimento',
  },
  taxonomy: taxonomyIt,
  disclaimer: {
    label: 'Avviso',
    body: 'Le curve di backtest e di ricerca sono educative. Non sono consulenza né una raccomandazione. I risultati passati non garantiscono quelli futuri. Il trading live include costi che i grafici ignorano.',
  },
  strategyDetail: {
    compare: 'Confronta in Performance',
    portfolio: 'Aggiungi al portafoglio',
    subscribe: 'Report settimanale',
    curveVsSpy: 'EQUITY RIBASATA vs INDICE = 100',
    pros: 'Perché esiste',
    cons: 'Contropartite',
    deepDive: 'Analisi completa',
  },
  strategies: {
    kicker: 'STRATEGIE SISTEMATICHE',
    colStrategy: 'STRATEGIA',
    volShort: 'VOL',
    modelsCtaTitle: 'Portafogli modello',
    modelsCtaBody: 'Mix già pronti di queste strategie, con lo stesso motore del costruttore di portafoglio.',
    openCard: 'Apri la scheda →',
    intradayCardHint: 'Dentro scegli l’esposizione: dal 50 % al 500 % del conto.',
    filterAll: 'Tutte',
    liveBadge: 'REALE',
    expandGroup: 'Mostra tutte le {n} ▸',
    collapseGroup: 'Mostra meno ▴',
    seeFamily: 'Vedi tutte le {n} →',
    sizing: {
      title: 'Dimensione intraday',
      exposure: 'Esposizione',
      exposureHint: '{pct} del conto sul Nasdaq mentre c’è una posizione; il numero di contratti deriva dalla dimensione del conto.',
      wholeContracts: 'I contratti sono interi: a questa esposizione un contratto richiede almeno {min} di conto, e 100.000 $ ne opererebbero oggi {n}.',
      grossNote: 'Al lordo di commissioni e slippage.',
    },
    variant: {
      label: 'Versione',
      standard: 'Standard',
      ucits: 'UCITS',
      cardHint: 'Dentro: versione Standard o UCITS.',
      notes: {
        heimdall: 'UCITS è il quadro UE per i fondi venduti agli investitori europei: stesso segnale, strumenti ammessi dalla normativa UCITS e limiti di concentrazione, in USD.',
        metis: 'UCITS è il quadro UE per i fondi venduti agli investitori europei: stesso segnale, oro e materie prime al massimo al 20 % ciascuno, il resto in liquidità, in USD.',
      },
    },
    strategyDescriptions: {
      tyr: 'Rotazione all-weather',
      ares: 'Market timing',
      ascalafo: 'Doppio strato',
      deimos: 'Timing + rischio',
      fobos: 'Doppio strato + rischio',
      bes: 'Trend following',
      janus: 'Market neutral',
      hraesvelgr: 'All-weather aggressivo',
      eos: 'Futures Nasdaq intraday',
      artemis: 'Un trade per sessione',
      helios: 'Continuazione oraria',
      hyperion: 'Tendenza diurna, solo long',
      horai: 'Programma intraday diversificato',
      theia: 'Programma intraday, long e short',
      astraeus: 'Una decisione al giorno, in entrambi i sensi',
      phaethon: 'Cavalca lo slancio della giornata',
      hemera: 'Dopo l’apertura, in entrambi i sensi',
      selene: 'Paziente, solo long',
      asteria: 'Una volta a settimana, solo il lunedì',
      aether: 'Programma intraday ampio',
      heimdall: 'Allocazione per regime macro',
      metis: 'Rotazione multi-asset per momentum',
    },
    strategyFullDescriptions: {
      tyr: 'TYR è una rotazione All-Weather diversificata. Distribuisce il rischio tra regimi economici poco correlati e regola le esposizioni con segnali proprietari. Prende il nome dal dio norreno dell’ordine e della disciplina.',
      ares: 'ARES è un market timing sistematico. Legge la salute strutturale del mercato nel suo insieme — non un singolo titolo — e passa da risk-on a risk-off. Validato nel 2008, 2020 e 2022. Live su Wikifolio.',
      ascalafo: 'ASCÁLAFO è un sistema di timing a due strati: i segnali indipendenti devono coincidere prima che l’esposizione giri. Stessa famiglia direzionale di ARES, con ingressi più stretti intorno ai regimi di volatilità.',
      deimos: 'DEIMOS è la manica di timing ad alto ottanaggio. La stessa logica di salute di mercato di ARES, più aggressiva quando i trend sono puliti, drawdown più duri quando non lo sono.',
      fobos: 'FOBOS aggiunge un overlay di volatilità sul timing con leva. Riduce il rischio quando i regimi di volatilità diventano ostili e rientra quando si calmano.',
      bes: 'BES è momentum azionario su più orizzonti. Tiene i nomi che battono il mercato ampio su più scale temporali e taglia quelli che non lo fanno.',
      janus: 'JANUS è selezione long/short market-neutral. Ribilanciamento settimanale, beta vicino a zero: un diversificatore, non una scommessa direzionale.',
      hraesvelgr: 'HRÆSVELGR è il gemello più aggressivo di TYR nella famiglia All Weather. La stessa disciplina di regime, più appetito di crescita e un giro più rapido in difesa quando il momentum si spegne.',
      eos: 'EOS prende il nome dalla dea greca dell’aurora. Opera i futures sul Nasdaq nelle prime ore della sessione: un ingresso sistematico e confermato nella direzione verso cui pende la giornata, stop e obiettivo fissi, flat prima della chiusura. Verificata con YGGDRASIL: Sharpe vicino a 1,5, beta zero verso l’indice. Mostrata con un’esposizione del 300 %, al lordo delle commissioni.',
      artemis: 'ARTEMIS prende il nome dalla dea arciera greca: una freccia per sessione. Una sola posizione sistematica sui futures del Nasdaq a inizio sessione, long o short, con stop e obiettivo fissi, flat alla chiusura; resta fuori nei grandi giorni macro. Verificata a un contratto fisso: Sharpe 1,3, beta zero. Mostrata con un’esposizione del 300 %, al lordo delle commissioni.',
      hyperion: 'HYPERION prende il nome dal titano della luce, quello che veglia dall’alto. Opera sui futures Nasdaq intraday e solo long: aspetta che la giornata scopra le carte, si unisce con stop e obiettivo fissi ed è fuori prima della chiusura. Verificata con YGGDRASIL a un contratto fisso: Sharpe 1,4, beta zero. Mostrata al 300 % di esposizione, al lordo delle commissioni.',
      helios: 'HELIOS prende il nome dal sole che attraversa il cielo: segue la strada che la giornata sta prendendo. Una volta all’ora verifica se i futures sul Nasdaq derivano con convinzione in una direzione e, se sì, si unisce a quel movimento con stop e obiettivo fissi, al massimo poche volte per sessione, sempre flat alla chiusura. Verificata a un contratto fisso: Sharpe 1,1, beta zero. Mostrata con un’esposizione del 300 %, al lordo delle commissioni.',
      horai: 'HORAI prende il nome dalle dee greche delle ore, che si dividono la giornata. Un programma intraday diversificato sui futures del Nasdaq: il conto è ripartito tra decisioni sistematiche indipendenti prese in momenti diversi della sessione, tutte flat alla chiusura. Quelle decisioni sono poco correlate, così conserva quasi tutto il rendimento con una frazione del drawdown di un singolo approccio. Mostrata con un’esposizione del 300 %, al lordo delle commissioni.',
      theia: 'THEIA prende il nome dalla titanide della vista, quella che vede l’intera giornata in una volta. Un programma intraday sistematico sui futures del Nasdaq, long e short, con più decisioni lungo la sessione e nulla aperto durante la notte. Verificata con YGGDRASIL. Mostrata con un’esposizione del 300 %, al lordo delle commissioni.',
      astraeus: 'ASTRAEUS prende il nome dal titano del crepuscolo, padre delle stelle e dei quattro venti. Opera sui futures del Nasdaq intraday, long o short, con al massimo una decisione al giorno e nulla aperto durante la notte. Verificata con YGGDRASIL a un contratto fisso: Sharpe 1,4, beta zero. Mostrata con un’esposizione del 300 %, al lordo delle commissioni.',
      phaethon: 'PHAETHON prende il nome dal figlio di Helios, quello che prese il carro del sole per un giorno. Opera sui futures del Nasdaq intraday, long o short, cavalcando lo slancio della giornata con uno stop fisso e fuori prima della chiusura. Verificata con YGGDRASIL a un contratto fisso: Sharpe 1,4, beta zero. Mostrata con un’esposizione del 300 %, al lordo delle commissioni.',
      hemera: 'HEMERA prende il nome dalla dea del giorno, figlia della Notte, quella che porta la luce ogni mattina. Opera sui futures del Nasdaq intraday, long o short, quando l’apertura ha già scoperto le carte, con stop e obiettivo fissi e flat alla chiusura. Verificata con YGGDRASIL a un contratto fisso: Sharpe 1,3, beta zero. Mostrata con un’esposizione del 300 %, al lordo delle commissioni.',
      selene: 'SELENE prende il nome dalla titanide della luna, sorella di Helios e di Eos. Opera sui futures del Nasdaq intraday e solo long, pochi giorni al mese, quelli che sceglie lei, ed è flat alla chiusura. Verificata con YGGDRASIL a un contratto fisso: non accettata, una regola dura fallita. Mostrata con un’esposizione del 300 %, al lordo delle commissioni.',
      asteria: 'ASTERIA prende il nome dalla titanide delle stelle cadenti, sorella di Latona, che divenne l’isola di Delo. Opera sui futures del Nasdaq solo long, una volta a settimana: compra la domenica sera per la sessione del lunedì ed è fuori prima della chiusura del lunedì, a un obiettivo fisso o a orario, senza stop. Verificata con YGGDRASIL a un contratto fisso: accettata, Sharpe 1,3, nessuna regola dura fallita; la regola del campione minimo (300 operazioni) è stata disattivata per decisione del titolare, perché opera una volta a settimana. Mostrata con un’esposizione del 300 %, al lordo delle commissioni.',
      aether: 'AETHER prende il nome dall’aria luminosa dell’alto, quella che respirano gli dèi, sopra il tempo che fa. Un programma intraday sistematico sui futures del Nasdaq, long e short, con più decisioni lungo la sessione e flat a ogni chiusura. Mostrata con un’esposizione del 300 %, al lordo delle commissioni.',
      heimdall: 'HEIMDALL prende il nome dalla sentinella del Bifröst, che tutto vede e tutto sente e suona il Gjallarhorn quando arriva il cambiamento. Ogni mese legge crescita e inflazione degli Stati Uniti dai dati così come erano stati pubblicati allora, li trasforma nelle probabilità di quattro regimi e ripartisce il portafoglio tra azioni, Treasury, TIPS, oro, materie prime e T-bill; un overlay di rischio settimanale riduce l’esposizione quando salgono la volatilità o lo stress. Due versioni con lo stesso segnale: Standard e UCITS. La versione Standard è stata verificata con YGGDRASIL: accettata.',
      metis: 'METIS prende il nome dalla titanide del buon consiglio, prima moglie di Zeus e madre di Atena. L’ultimo giorno di borsa di ogni mese tiene i tre degli otto mercati (azioni, Treasury, oro, materie prime, immobiliare) saliti di più in sei mesi, solo se sono in rialzo, altrimenti liquidità; un freno di volatilità la riduce sopra il 15 %. Due versioni, stesso segnale: Standard e UCITS. La versione Standard è stata verificata con YGGDRASIL: accettata. La versione UCITS non è stata accettata (due regole dure mancate) ed è pubblicata per decisione del proprietario.',
    },
  },
  home: {
    ticker: {
      subtitle: 'Ricerca sistematica · track record live',
    },
    hero: {
      lead: 'Ventidue strategie sistematiche. Diverse sono live da anni — puoi seguirle su Wikifolio, Darwinex ed eToro. In ogni pagina, i numeri.',
      live: 'Track record live',
      ctaReports: 'Report settimanali',
      ctaTerminal: 'Apri il Terminale',
    },
    regimeTeaser: {
      kicker: 'PROPRIETARIO',
      title: 'Il rilevatore di regime HMA',
      body: 'Sei modelli di Markov nascosti. Un composito, walk-forward. Il desk live intorno. Abbonati per aprirlo.',
      cta: 'Vedi il Terminale',
    },
    featured: {
      subtitle: 'Direzionale · salute di mercato',
      cta: 'Apri ARES →',
      description: 'Market timing da un composito di salute: restare investiti quando le condizioni lo sostengono, uscire quando no. Live su Wikifolio.',
    },
    families: {
      title: 'Sei famiglie',
      subtitle: 'Lo stesso processo di ricerca, lavori diversi in un portafoglio. Apri una famiglia per vedere le strategie.',
    },
    snapshot: {
      label: 'EQUITY, STESSO INIZIO',
      title: 'TYR contro indici azionari',
      hint: 'Stessa data di inizio, ribasato a 100. Scala log perché TYR e gli indici restino leggibili insieme.',
      cta: 'Apri Performance',
    },
    products: {
      title: 'A cosa puoi iscriverti',
      reportsKicker: 'RICERCA',
      reportsTitle: 'Report settimanali',
      reportsBody: 'Metodologia, evoluzione del portafoglio e la settimana appena chiusa — per strategia o nel pacchetto.',
      reportsCta: 'Vedi i piani',
      terminalKicker: 'REGIME',
      terminalTitle: 'HMA Terminal',
      terminalBody: 'Il rilevatore di regime proprietario a sei fattori di HMA — più il desk live intorno. Aprilo.',
      terminalCta: 'Apri il Terminale',
    },
    instTeaser: {
      title: 'Mandati, non una scheda prodotto',
      body: 'Design di strategie, regime e overlay di rischio per fondi, family office e desk che hanno bisogno di chi costruisce.',
      cta: 'Vedi la pagina mandati',
    },
  },
  insights: {
    title: 'Ricerca',
    subtitle: 'Note quantitative su Substack. Il calendario e il motore di regime stanno nel Terminale.',
    marketContext: 'Contesto di mercato',
    marketContextHint: 'Regime, STIR e strumenti di liquidità completi sono nel Terminale.',
    openTerminal: 'Apri il Terminale',
    whereToInvestSubtitle: 'Diverse strategie sono live, con un track record reale su piattaforme regolamentate.',
    readOnSubstack: 'Leggi su Substack →',
    strategyNamed: 'Strategia {name}',
  },
  weeklyReports: {
    revealPrice: 'Vedi il prezzo e abbonati →',
    universeLabel: 'Universo',
    popular: 'Popolare',
    universe: {
      diversified: 'ETF diversificati',
      index: 'ETF sugli indici',
      equities: 'Azioni quotate',
      leveraged: 'ETF con leva',
      futures: 'Futures sul Nasdaq',
    },
    cards: {
      TYR: 'Rotazione All-Weather — report settimanale di ricerca',
      HRAESVELGR: 'Rotazione All Weather più aggressiva — report settimanale di ricerca',
      ARES: 'Timing macro e protezione — report settimanale di ricerca',
      JANUS: 'Long/short market-neutral — report settimanale di ricerca',
      BES: 'Momentum azionario su più orizzonti — report settimanale di ricerca',
      ASCALAFO: 'Timing macro con overlay di volatilità — report settimanale di ricerca',
      DEIMOS: 'Timing macro aggressivo — report settimanale di ricerca',
      FOBOS: 'Timing con leva e overlay di volatilità — report settimanale di ricerca',
      EOS: 'Futures Nasdaq intraday — report settimanale di ricerca',
      ARTEMIS: 'Un trade per sessione sui futures Nasdaq — report settimanale di ricerca',
      HELIOS: 'Continuazione di tendenza oraria sui futures Nasdaq — report settimanale di ricerca',
      HYPERION: 'Tendenza diurna sui futures Nasdaq, solo long — report settimanale di ricerca',
      HORAI: 'Programma intraday diversificato sui futures Nasdaq — report settimanale di ricerca',
      THEIA: 'Programma intraday sui futures Nasdaq, long e short — report settimanale di ricerca',
      ASTRAEUS: 'Una decisione al giorno sui futures Nasdaq, long e short — report settimanale di ricerca',
      PHAETHON: 'Momentum intraday sui futures Nasdaq, long e short — report settimanale di ricerca',
      HEMERA: 'Dopo l’apertura sui futures Nasdaq, long e short — report settimanale di ricerca',
      SELENE: 'Giornate pazienti, solo long, sui futures Nasdaq — report settimanale di ricerca',
      ASTERIA: 'Long del lunedì sui futures Nasdaq, una volta a settimana — report settimanale di ricerca',
      AETHER: 'Programma intraday ampio sui futures Nasdaq — report settimanale di ricerca',
      HEIMDALL: 'Allocazione multi-asset per regime macro, Standard e UCITS — report settimanale di ricerca',
      METIS: 'Rotazione multi-asset per momentum, Standard e UCITS — report settimanale di ricerca',
    },
    disclaimerLabel: 'Avviso',
    disclaimer: 'Questi report sono solo informativi ed educativi. Descrivono metodologia, modelli e l’evoluzione del portafoglio di ciascuna strategia. NON sono segnali di trading, consulenza di investimento né raccomandazioni personalizzate. I risultati passati non garantiscono quelli futuri. Fai le tue ricerche e consulta un consulente abilitato prima di investire.',
    notAvailable: 'Questa strategia non è ancora disponibile all’acquisto',
    bundleNotAvailable: 'Il pacchetto non è ancora disponibile all’acquisto',
    checkoutFailed: 'Impossibile creare la sessione di pagamento',
    checkoutStartFailed: 'Impossibile avviare il pagamento. Riprova.',
  },
  checkout: {
    missingPrice: 'Questo prodotto non è ancora disponibile — manca il prezzo Stripe.',
    checkoutFailed: 'Impossibile avviare il pagamento',
    checkoutError: 'Errore di pagamento: {message}',
    noSubscription: 'Nessun abbonamento attivo',
    portalFailed: 'Impossibile aprire la gestione abbonamenti. Riprova.',
  },
  contact: {
    fillAll: 'Compila tutti i campi',
    sent: 'Messaggio inviato. Risponderò presto.',
    sendError: 'Errore nell’invio. Riprova.',
    connectionError: 'Errore di connessione. Riprova più tardi.',
    sending: 'Invio…',
    methodLabel: 'Metodo di contatto',
    methodHint: 'Usa il modulo per inviarmi un messaggio. Di solito rispondo entro 24–48 ore.',
  },
  common: {
    present: 'Oggi',
  },
  performancePage: {
    kicker: 'ANALISI',
    title: 'Rendimento',
    lead: 'Confronta le strategie tra loro e con gli indici. Sharpe, drawdown, correlazione e rischio, dalle curve pubblicate.',
    dateRange: 'Intervallo di date',
    dateHint: 'Ogni serie è ritagliata alle date sovrapposte in questo intervallo e ribasata a 100 all’inizio comune.',
    equity: 'Curve di capitale',
    logScale: 'Scala log',
    showRegime: 'Overlay di regime di mercato',
    regimeHint: 'Il colore di sfondo è il composito a sei fattori (risk-on → risk-off). È una lettura di mercato, non un segnale di strategia.',
    regimeOn: 'Risk-on',
    regimeNeutral: 'Neutrale',
    regimeCautious: 'Cauto',
    regimeOff: 'Risk-off',
    rollingSharpe: 'Sharpe mobile',
    months: '{n} mesi',
    drawdown: 'Drawdown',
    underwater: 'sott’acqua',
    correlation: 'Correlazione',
    correlationHint: 'Rendimenti mensili · Pearson',
    metrics: 'Metriche comparative',
    strategies: 'Strategie',
    benchmarks: 'Benchmark',
    selectAll: 'Seleziona tutto',
    clear: 'Pulisci',
    needTwo: 'Seleziona almeno due serie per vedere le correlazioni',
    needOne: 'Seleziona almeno una serie per vedere le metriche',
    needOneEquity: 'Seleziona almeno una strategia o un benchmark',
    needOneDrawdown: 'Seleziona almeno una serie per vedere il drawdown',
    needOneSharpe: 'Seleziona almeno una serie per vedere lo Sharpe mobile',
    rebased: 'Ribasato a 100',
    rebasedFrom: 'Ribasato a 100 · {date}',
    series: 'Serie',
    totalReturn: 'Rendimento totale',
    volatility: 'Volatilità',
    upMonths: '% mesi positivi',
    metricsNote: 'Le metriche sono calcolate sulla finestra comune delle serie selezionate',
    metricsNoteRange: 'nell’intervallo di date contrassegnato',
    metricsNoteAnnual: 'Sharpe e Sortino usano rendimenti giornalieri in eccesso sui T-bill a 3 mesi, annualizzati con 252 giorni di trading (curve settimanali: rendimenti settimanali, 52).',
    maxPreset: 'Max',
    typeStrategy: 'strategia',
    typeBenchmark: 'benchmark',
  },
  portfolioPage: {
    kicker: 'COSTRUTTORE DI PORTAFOGLIO',
    title: 'Costruisci il tuo portafoglio',
    lead: 'Combina le strategie HMA con pesi personalizzati, scegli la frequenza di ribilanciamento e fai il backtest del portafoglio rispetto ai principali benchmark.',
    presets: 'Preset rapidi',
    loadModel: 'Carica un portafoglio modello',
    findProfile: 'Trova il mio profilo di rischio',
    optimizing: 'Ottimizzazione…',
    optimize: 'Ottimizza per lo Sharpe massimo',
    optimizeFailed: 'Ottimizzazione fallita — prova un’altra frequenza di ribilanciamento.',
    components: 'Componenti del portafoglio',
    select: 'Scegli…',
    addComponent: 'Aggiungi componente',
    totalOk: 'Totale: {n}%',
    totalUnder: 'Totale: {n}% — resta {left}%',
    totalOver: 'Totale: {n}% — supera il 100%',
    autoBalance: 'Auto-bilancia',
    rebalancing: 'Frequenza di ribilanciamento',
    rebalanceHint: 'Il ribilanciamento riporta periodicamente i pesi alla tua allocazione obiettivo.',
    monthly: 'Mensile',
    quarterly: 'Trimestrale',
    annually: 'Annuale',
    never: 'Mai (compra e tieni)',
    logScale: 'Scala log',
    rebased: 'Ribasato a 100',
    calculate: 'Calcola portafoglio',
    copied: 'Copiato!',
    copyLink: 'Copia link',
    models: 'Portafogli modello',
    modelsHint: 'Carica un mix pronto e calcola. Oppure costruisci il tuo a sinistra.',
    myPortfolio: 'Il mio portafoglio',
    allocation: 'Allocazione',
    backtestRange: 'Intervallo del backtest',
    years: '{n} anni',
    rebalanced: 'Ribilanciamento: {freq}',
    equityCurve: 'Curva di capitale',
    fullMetrics: 'Metriche complete',
    valueBase: 'Valore (base 100)',
    returnPct: 'Rendimento (%)',
    sharpeRatio: 'Rapporto Sharpe',
    maxDrawdown: 'Max drawdown',
    ddDuration: 'Durata DD',
    bestYear: 'Anno migliore',
    worstYear: 'Anno peggiore',
    posMonths: 'Mesi pos.',
    compareVs: 'Confronta con',
    benchmarksHint: 'Le linee tratteggiate sono indici di riferimento. Non fanno parte del portafoglio.',
  },
  terminalLanding: {
    badge: 'RILEVATORE DI REGIME PROPRIETARIO',
    title: 'Un rilevatore del regime di mercato — costruito qui.',
    lead: 'Sei modelli di Markov nascosti si condensano in un composito, da risk-on a risk-off. Intorno, il desk live: macro, funding, interni. Aprilo ogni giorno.',
    price: '10,99 € / mese.',
    ctaSignIn: 'Accedi per abbonarti',
    ctaOpen: 'Apri il Terminale →',
    ctaBusy: 'Reindirizzamento…',
    ctaUnlock: 'Sblocca a 10,99 € / mese',
    seeInside: 'Vedi il rilevatore',
    subscribed: 'Sei abbonato — l’accesso è attivo.',
    liveNow: 'COMPOSITO LIVE',
    liveAsOf: 'al {date}',
    regimeEyebrow: 'IL MOTORE',
    regimeTitle: 'Il rilevatore di regime HMA',
    regimeLead: 'Questo è il nucleo proprietario del Terminale. Sei HMM gaussiani indipendenti — volatilità, trend, ampiezza, ciclo, liquidità, valutazione — ciascuno inferisce uno stato latente e un rischio ponderato. La loro media è il composito. Ogni giorno è walk-forward: solo informazioni di quel giorno. Non è un ticket. È una lettura del nastro.',
    regimePoints: [
      { t: 'Proprietario', d: 'Progettato e gestito qui. Lo stesso motore con cui HMA legge il mercato — ora sul tuo schermo.' },
      { t: 'Sei fattori', d: 'Volatilità, trend, ampiezza, ciclo, liquidità, valutazione. Modelli indipendenti, un composito.' },
      { t: 'Walk-forward', d: 'Niente look-ahead. Ogni giorno è filtrato sul proprio passato. Una storia di cui ti puoi fidare.' },
      { t: 'Composito ed esposizione', d: 'Un numero da 0 (risk-on) a 1 (risk-off). Esposizione suggerita = 1 − composito, con isteresi di 5 giorni.' },
    ],
    shotsEyebrow: 'IL DESK',
    shotsTitle: 'Cosa apri quando ti abboni',
    shots: [
      { t: 'Rilevatore di regime', d: 'Composito, lavagna a sei fattori, storia causale.' },
      { t: 'Nastro di liquidità', d: 'Liquidità netta, tassi overnight, la curva.' },
      { t: 'Monitor STIR', d: 'Corridoio, riserve, stress di funding.' },
      { t: 'Dashboard macro', d: 'Rendimenti, inflazione, lavoro, credito, stress.' },
      { t: 'Interni di mercato', d: 'Partecipazione sotto l’indice.' },
      { t: 'Repo privato', d: 'Tassi overnight, volumi, uso delle facility.' },
    ],
    lockedEyebrow: 'BLOCCATO',
    lockedTitle: 'Altri pannelli, dietro il lucchetto',
    lockedHint: 'Abbonati per aprire l’esploratore di fattori, credito, facility e alert di ampiezza — non solo le copertine.',
    lockedCta: 'Sblocca',
    lockedShots: [
      { t: 'Esploratore di fattori' },
      { t: 'Credito e stress' },
      { t: 'Uso delle facility' },
      { t: 'Alert di ampiezza' },
      { t: 'Guida sul campo' },
      { t: 'Funding overnight' },
      { t: 'Storia dei fattori' },
      { t: 'Liquidità da vicino' },
    ],
    previewKicker: 'ANTEPRIMA LIVE',
    previewTitle: 'Il terminale vero gira sotto. Abbonati per togliere il blur.',
    insideEyebrow: 'COSA OTTIENI',
    insideTitle: 'Il rilevatore, poi tutto il desk',
    features: [
      { t: 'Rilevatore di regime HMA', d: 'Sei HMM gaussiani indipendenti. Un composito da risk-on a risk-off. Costruito qui, non in licenza.' },
      { t: 'Composito ed esposizione', d: 'Un numero da 0 a 1, esposizione suggerita 1 − composito, e isteresi di 5 giorni perché l’etichetta non lampeggi.' },
      { t: 'Storia walk-forward', d: 'Ogni giorno valutato con informazioni di quel giorno — senza look-ahead. Un sentiero di regime da backtestare.' },
      { t: 'Esploratore di fattori', d: 'Apri qualsiasi fattore: stato live, traiettoria di rischio e gli indicatori che alimentano il modello.' },
      { t: 'Nastro di liquidità', d: 'Liquidità netta di sistema vs l’indice, tassi overnight e la curva 2s10s — la marea, in uno schermo.' },
      { t: 'Monitor STIR', d: 'Corridoio overnight, code, riserve vs reverse-repo, spread di funding e asset money-market — dove lo stress appare per primo.' },
      { t: 'Interni di mercato', d: 'Mover del 4%, ratio a 5 e 10 giorni, massimi/minimi a 25 giorni e la spinta 13/34 — non solo l’indice.' },
      { t: 'Dashboard macro', d: 'Curva completa, inflazione e lavoro, credito HY vs IG, indici di condizioni finanziarie, dollaro e petrolio.' },
      { t: 'Repo privato', d: 'Tassi e volumi overnight tri-party, DVP e GCF, accanto all’uso delle facility e alle controparti.' },
      { t: 'Guida sul campo', d: 'Note chiare su ogni serie: cosa significa, perché si muove e come leggerla.' },
    ],
    howEyebrow: 'COME FUNZIONA',
    howTitle: 'Il rilevatore valuta il giorno. Tu lo leggi.',
    steps: [
      { n: '01', t: 'Sei modelli valutano oggi', d: 'Ogni fattore inferisce uno stato latente e un rischio in [0,1] — strettamente causale, senza look-ahead.' },
      { n: '02', t: 'Un composito', d: 'Media equiponderata, isteresi, esposizione suggerita. Da risk-on a risk-off, in un solo numero.' },
      { n: '03', t: 'Apri il Terminale', d: 'Il rilevatore, la storia, l’esploratore e il resto del desk — pronti al login.' },
    ],
    membership: 'ABBONAMENTO',
    perMonth: '/ mese',
    cancel: 'Disdici quando vuoi · fatturazione mensile',
    bullets: [
      'Rilevatore di regime proprietario a sei fattori',
      'Composito live ed esposizione suggerita',
      'Storia di regime walk-forward',
      'Esploratore di fattori',
      'Pannelli macro, STIR, interni e repo',
      'Guida sul campo su ogni serie',
      'Aggiornamenti ogni giorno',
    ],
    faqEyebrow: 'FAQ',
    faqTitle: 'Buono a sapersi',
    faq: [
      { q: 'Cosa sto pagando esattamente?', a: 'Accesso live al Terminale: il rilevatore di regime proprietario di HMA, l’esploratore di fattori, la storia causale e il resto del desk — aggiornato ogni giorno.' },
      { q: 'Cos’è il rilevatore di regime?', a: 'Un motore a sei HMM costruito qui. Non ti dice cosa comprare. Ti dice lo stato di rischio del mercato, ogni giorno, senza look-ahead.' },
      { q: 'È consulenza di investimento?', a: 'No. È uno strumento di ricerca e monitoraggio. Tutto è educativo e informativo — non una raccomandazione di acquisto o vendita.' },
      { q: 'Posso disdire in qualsiasi momento?', a: 'Sì. È un abbonamento mensile che disdici con un clic dal tuo account; l’accesso resta fino alla fine del periodo fatturato.' },
    ],
    disclaimer: 'Il Terminale hmaquant è uno strumento di ricerca e monitoraggio quantitativo a fini educativi e informativi. Non è consulenza di investimento e nulla in esso costituisce una raccomandazione di acquisto o vendita di alcun titolo.',
  },
  reportsFaq: {
    title: 'FAQ',
    items: [
      { q: 'Cosa sto comprando?', a: 'Un report settimanale di ricerca su quella strategia: metodologia, evoluzione del portafoglio e la settimana precedente. Non è un ticket di trading né consulenza personalizzata.' },
      { q: 'Posso disdire?', a: 'Sì. Gestisci l’abbonamento dal tuo account. L’accesso resta fino alla fine del periodo fatturato.' },
      { q: 'Cos’è il piano annuale?', a: 'Dieci mesi fatturati, due mesi gratis. Lo stesso report, fattura annuale.' },
      { q: 'Il pacchetto include il Terminale?', a: 'Il pacchetto copre i ventidue report di strategia e le note macro. Il Terminale è un prodotto separato a 10,99 €.' },
    ],
  },
  footer: {
    tagline: 'Ricerca sistematica. Ventidue strategie, un processo.',
    intradayNote: 'Le curve delle strategie intraday su futures (EOS, ARTEMIS, HELIOS, HYPERION, HORAI, THEIA, ASTRAEUS, PHAETHON, HEMERA, SELENE, ASTERIA, AETHER) sono mostrate al lordo di commissioni e slippage, con un’esposizione costante del 300 % del conto (i contratti seguono la dimensione del conto), su un backtest replicato dalla verifica di YGGDRASIL.',
  },
  accountHub: {
    reports: 'I miei report',
    terminal: 'Terminale',
    lab: 'Lab quantitativo',
  },
  quantLabPage: {
    kicker: 'SANDBOX',
    blurb: 'Simulazioni educative — GBM, mean reversion, Markov nascosto, greeks. Non è il desk live.',
    openTerminal: 'Apri il Terminale',
    versionBar: 'QUANT LAB v1.0 · HMA QUANT STRATEGIES',
  },
  terminalChrome: {
    lab: 'Sandbox educativo · non è consulenza',
    modules: '{n} moduli',
  },
  institutionalPage: {
    kicker: 'MANDATI',
    heroTitle: 'Costruito per il tuo book. Non un catalogo di prodotti.',
    heroBody: 'HMA prende mandati di ricerca istituzionale — design sistematico, lavoro di regime e overlay di rischio — per fondi, family office e desk che hanno bisogno di chi costruisce, non di un altro newsletter.',
    ctaPrimary: 'Invia un brief',
    ctaSecondary: 'Come lavoriamo',
    proofKicker: 'IN PUBBLICO',
    proof: [
      { value: '12', label: 'strategie sistematiche live' },
      { value: 'Live', label: 'Track record su Wikifolio, Darwinex ed eToro' },
      { value: '6 HMM', label: 'motore di regime proprietario, walk-forward' },
      { value: 'Desk', label: 'Fisica, finanza quantitativa, buy-side e broker' },
    ],
    forTitle: 'Chi dovrebbe scrivere',
    forBody: 'Se la domanda ce l’hai già, si può chiudere lo scope in una call. Se ti serve una brochure da vendor, questa non è la pagina.',
    for: [
      { title: 'Family office / allocator', body: 'Uno sleeve che deve guadagnarsi il posto accanto al resto del book. Progettiamo processo, risk budget e kill-switch — non un pitch deck di backtest.' },
      { title: 'CIO / rischio', body: 'Un overlay di regime, un protocollo di drawdown, o una lettura indipendente su se il book attuale è ancora quello che pensavi di avere.' },
      { title: 'Desk sistematico', body: 'Un modulo che non vuoi staffare internamente: research di segnale, walk-forward, spec di monitoraggio, o un secondo paio di occhi su un processo live.' },
    ],
    workTitle: 'Mandati che prendiamo',
    workBody: 'Il sito pubblico è il work sample. Un mandato va oltre: i tuoi dati, i tuoi vincoli, il tuo book.',
    work: [
      { title: 'Design di strategie sistematiche', body: 'Dall’ipotesi a un processo che puoi far girare. Universo, segnali, assunti di esecuzione, walk-forward e i modi di fallimento scritti prima che il capitale sia a rischio.', tag: 'Nuovo sleeve · rebuild' },
      { title: 'Regime e ricerca macro', body: 'Lo stack a sei HMM del Terminale, specificato al tuo book: quando aggiungere rischio, quando tagliare, cosa significa neutrale per te.', tag: 'Overlay · timing' },
      { title: 'Overlay di rischio e protocolli di drawdown', body: 'Kill-switch, vol targeting, sentieri di stress e regole che un CIO può difendere in un comitato — non un VaR su una slide.', tag: 'Rischio · overlay' },
      { title: 'Costruzione di portafoglio', body: 'Come stanno insieme i pezzi. Risk budget, regimi di correlazione, e cosa fare quando due diversificatori iniziano a muoversi come uno.', tag: 'Family office · multi-strategy' },
      { title: 'Research in retainer', body: 'Cadenza settimanale o mensile: note, diagnostica e qualcuno che già conosce il book. Più vicino a un desk che a un PDF di consulenza.', tag: 'Continuo' },
    ],
    processTitle: 'Come gira un incarico',
    processBody: 'Scope corto, assunti per iscritto, il lavoro resta a te.',
    process: [
      { n: '01', title: 'Brief', body: 'Invii la domanda, i vincoli e cosa significa fatto. Diciamo sì, no, o non ancora.' },
      { n: '02', title: 'Scope', body: 'Una nota breve: deliverable, dati che servono, tempi, fee. Niente spedizione di pesca.' },
      { n: '03', title: 'Build', body: 'Research in aperto con te. Codice, grafici e assunti scritti perché qualcun altro possa rilanciarli.' },
      { n: '04', title: 'Consegna', body: 'Il lavoro resta a te. Retainer opzionale per tenere vivo il processo quando cambia il regime.' },
    ],
    deliverTitle: 'Con cosa resti',
    deliver: [
      { title: 'Un processo scritto', body: 'Non una black box. Segnali, dati e le regole su quando può operare.' },
      { title: 'Un pack di research', body: 'Walk-forward, casi di fallimento e grafici che un comitato può leggere davvero.' },
      { title: 'Codice se lo vuoi', body: 'Notebook riproducibili o un piccolo servizio. Da far girare tu.' },
      { title: 'Una spec operativa', body: 'Cosa monitorare, cosa killare, chi riceve l’alert.' },
    ],
    notTitle: 'Cosa non è',
    notItems: [
      'Non custodiamo il tuo AUM. Il track record live è su piattaforme regolamentate — prova di processo, non una raccolta di fondo.',
      'Non vendiamo un dump di segnali né un modello senza owner.',
      'Non prendiamo ogni brief. Se è una newsletter, il prodotto è in Report. Se è un problema di desk, scrivi.',
    ],
    sampleTitle: 'Il work sample pubblico',
    sampleBody: 'Strategie, Performance e il Terminale sono ciò che già facciamo girare. Un mandato è lo stesso mestiere, specificato a te.',
    samples: [
      { to: '/strategies', label: 'Ventidue strategie' },
      { to: '/performance', label: 'Performance' },
      { to: '/terminal', label: 'Desk di regime' },
    ],
    formKicker: 'INTAKE',
    formTitle: 'Invia un brief breve',
    formBody: 'Firma, il problema, il vincolo. Rispondiamo noi.',
    formName: 'Nome',
    formFirm: 'Firma',
    formEmail: 'Email',
    formNeed: 'Cosa ti serve',
    formNeedPlaceholder: 'Scegli un mandato',
    formMessage: 'Il brief',
    formSend: 'Invia brief',
    formSending: 'Invio…',
    formOk: 'Ricevuto. Ti scriviamo.',
    formErr: 'Non è partito da qui — usa il link mail e arriva lo stesso.',
    formMail: 'Scrivi per email →',
    formNote: 'Riservato. Niente coda commerciale. Se il brief non calza, lo diciamo.',
    needs: [
      { id: 'strategy', label: 'Design di strategia' },
      { id: 'regime', label: 'Regime / overlay' },
      { id: 'risk', label: 'Rischio / protocollo di drawdown' },
      { id: 'portfolio', label: 'Costruzione di portafoglio' },
      { id: 'retain', label: 'Research in retainer' },
      { id: 'other', label: 'Altro — lo spiego' },
    ],
    ctaLine: 'Se la domanda già non ti fa dormire, scrivila.',
  },
};
